const CURRENCY_LOCALES = {
  CZK: 'cs-CZ',
  PLN: 'pl-PL',
  EUR: 'de-DE',
  USD: 'en-US'
};

const CURRENCY_FRACTION_DIGITS = {
  CZK: 0,
  PLN: 0,
  EUR: 2,
  USD: 2
};

export function formatCurrency(amount, options = {}, locale) {
  if (typeof Intl !== 'undefined' && Intl.NumberFormat) {
    const currency = options.currency || 'CZK';
    const resolvedLocale = locale || CURRENCY_LOCALES[currency] || 'cs-CZ';
    const defaultFraction = CURRENCY_FRACTION_DIGITS[currency] ?? 2;

    const formatOptions = {
      style: 'currency',
      currency,
      minimumFractionDigits: defaultFraction,
      maximumFractionDigits: defaultFraction,
      ...options
    };

    return new Intl.NumberFormat(resolvedLocale, formatOptions).format(amount);
  }

  // Fallback pro staré prohlížeče
  const digits = CURRENCY_FRACTION_DIGITS[options.currency] ?? 2;
  return amount.toFixed(digits) + ' ' + (options.currency || 'CZK');
}
